import { useState } from "react";
import { fmt } from "./Utils/Utilities";
import { Badge } from "./SharedUI";

// ─── Mock Data ────────────────────────────────────────────────────────────────
const MOCK_ALLOCATIONS = [
  { id: "ALO-3001", orderId: "ORD-8821", employee: "M. van der Merwe", employeeId: "EMP-2001", product: "Industrial Oxygen",  qty: 400,    site: "Sky Hill",    allocatedBy: "System (Auto)", allocatedAt: "2025-04-22 08:14", fulfilledAt: "2025-04-23 10:30", status: "Fulfilled",  adjustments: 0 },
  { id: "ALO-3002", orderId: "ORD-8822", employee: "T. Nkosi",          employeeId: "EMP-2002", product: "Medical Oxygen",     qty: 1200,   site: "Sasol",       allocatedBy: "T. Nkosi",       allocatedAt: "2025-04-22 09:00", fulfilledAt: "2025-04-22 14:00", status: "Fulfilled",  adjustments: 0 },
  { id: "ALO-3003", orderId: "ORD-8830", employee: "S. Mokoena",        employeeId: "EMP-2003", product: "Acetylene",          qty: 80,    site: "Moonstone",   allocatedBy: "System (Auto)", allocatedAt: "2025-04-24 07:45", fulfilledAt: null,               status: "Pending",    adjustments: 1 },
  { id: "ALO-3004", orderId: "ORD-8831", employee: "A. Naidoo",         employeeId: "EMP-2004", product: "Argon Mix",          qty: 200,    site: "Sky Hill",    allocatedBy: "T. Nkosi",       allocatedAt: "2025-04-24 08:30", fulfilledAt: null,               status: "In Transit", adjustments: 0 },
  { id: "ALO-3005", orderId: "ORD-8835", employee: "P. Molefe",         employeeId: "EMP-2005", product: "Food Grade CO₂",     qty: 500,  site: "Sasol",       allocatedBy: "System (Auto)", allocatedAt: "2025-04-25 06:00", fulfilledAt: null,               status: "In Transit", adjustments: 0 },
  { id: "ALO-3006", orderId: "ORD-8836", employee: "R. Dlamini",        employeeId: "EMP-2006", product: "Food Grade CO₂",     qty: 300,   site: "Sasol",       allocatedBy: "R. Dlamini",     allocatedAt: "2025-04-25 09:15", fulfilledAt: null,               status: "Pending",    adjustments: 0 },
  { id: "ALO-3007", orderId: "ORD-8840", employee: "C. van Wyk",        employeeId: "EMP-2007", product: "LPG Bulk",           qty: 2000,   site: "Moonstone",   allocatedBy: "System (Auto)", allocatedAt: "2025-04-26 07:00", fulfilledAt: null,               status: "Cancelled",  adjustments: 2 },
  { id: "ALO-3008", orderId: "ORD-8841", employee: "T. Nkosi",          employeeId: "EMP-2002", product: "Nitrogen",           qty: 150,    site: "Sky Hill",    allocatedBy: "T. Nkosi",       allocatedAt: "2025-04-26 10:00", fulfilledAt: "2025-04-27 09:45", status: "Fulfilled",  adjustments: 0 },
  { id: "ALO-3009", orderId: "ORD-8845", employee: "L. Park",           employeeId: "EMP-2008", product: "Helium",             qty: 50,     site: "Sasol",       allocatedBy: "R. Dlamini",     allocatedAt: "2025-04-27 11:00", fulfilledAt: "2025-04-28 08:00", status: "Fulfilled",  adjustments: 0 },
  { id: "ALO-3010", orderId: "ORD-8850", employee: "M. van der Merwe", employeeId: "EMP-2001", product: "Industrial Oxygen",  qty: 600,    site: "Sky Hill",    allocatedBy: "System (Auto)", allocatedAt: "2025-04-28 07:30", fulfilledAt: null,               status: "Pending",    adjustments: 1 },
  { id: "ALO-3011", orderId: "ORD-8851", employee: "T. Nkosi",          employeeId: "EMP-2002", product: "Medical Oxygen",     qty: 800,   site: "Sasol",       allocatedBy: "T. Nkosi",       allocatedAt: "2025-04-28 08:00", fulfilledAt: null,               status: "In Transit", adjustments: 0 },
  { id: "ALO-3012", orderId: "ORD-8860", employee: "S. Mokoena",        employeeId: "EMP-2003", product: "Propane",            qty: 100,   site: "Moonstone",   allocatedBy: "System (Auto)", allocatedAt: "2025-04-29 06:15", fulfilledAt: "2025-04-30 11:00", status: "Fulfilled",  adjustments: 0 },
];

const STATUS_COLORS = {
  Fulfilled:   { color: "var(--success)", bg: "rgba(0,230,118,.1)",   border: "rgba(0,230,118,.25)"  },
  "In Transit":{ color: "var(--blue)",    bg: "rgba(64,196,255,.1)",  border: "rgba(64,196,255,.25)" },
  Pending:     { color: "var(--amber)",   bg: "rgba(255,171,0,.1)",   border: "rgba(255,171,0,.25)"  },
  Cancelled:   { color: "var(--danger)",  bg: "rgba(255,23,68,.1)",   border: "rgba(255,23,68,.25)"  },
};

function StatusPill({ status }) {
  const s = STATUS_COLORS[status] || STATUS_COLORS["Pending"];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "2px 8px", borderRadius: 20, fontSize: 10, fontWeight: 700, color: s.color, background: s.bg, border: `1px solid ${s.border}` }}>
      <span style={{ width: 5, height: 5, borderRadius: "50%", background: s.color, display: "inline-block" }} />
      {status}
    </span>
  );
}

// ─── Depot breakdown mini chart ───────────────────────────────────────────────
function SiteBreakdown({ allocations }) {
  const sites = [...new Set(allocations.map((a) => a.site))];
  const max   = Math.max(...sites.map((s) => allocations.filter((a) => a.site === s).length));
  return (
    <div className="panel" style={{ marginBottom: 16 }}>
      <div className="ph"><span className="ph-title">Allocations by Site</span></div>
      <div style={{ padding: "14px 18px" }}>
        {sites.map((s) => {
          const items = allocations.filter((a) => a.site === s);
          const pct   = (items.length / max) * 100;
          const fulfilled = items.filter((a) => a.status === "Fulfilled").length;
          return (
            <div key={s} style={{ marginBottom: 14 }}>
              <div className="fb" style={{ marginBottom: 5 }}>
                <span className="fs11 fw6">{s}</span>
                <span className="fs10 tc3">{fulfilled}/{items.length} fulfilled</span>
              </div>
              <div className="prog-wrap" style={{ height: 6 }}>
                <div className="prog-fill" style={{ width: `${pct}%`, background: "var(--teal)" }} />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// ─── KPI Cards ────────────────────────────────────────────────────────────────
function AllocationKPIs({ allocations }) {
  const total      = allocations.length;
  const fulfilled  = allocations.filter((a) => a.status === "Fulfilled").length;
  const pending    = allocations.filter((a) => a.status === "Pending").length;
  const cancelled  = allocations.filter((a) => a.status === "Cancelled").length;
  const adjusted   = allocations.filter((a) => a.adjustments > 0).length;
  const fillRate   = Math.round((fulfilled / total) * 100);

  const cards = [
    { label: "Total Allocations",  value: total,        accent: "linear-gradient(90deg,var(--blue),var(--teal))",    sub: "all sites combined",         valueClass: "" },
    { label: "Fulfillment Rate",   value: `${fillRate}%`, accent: "linear-gradient(90deg,var(--success),var(--teal))", sub: `${fulfilled} fulfilled`,     valueClass: "t-success" },
    { label: "Pending Dispatch",   value: pending,       accent: "linear-gradient(90deg,var(--amber),var(--flame))",  sub: "awaiting fulfilment",         valueClass: "t-amber"   },
    { label: "Adjustments Made",   value: adjusted,      accent: "linear-gradient(90deg,var(--flame),var(--danger))", sub: `${cancelled} cancelled`,      valueClass: cancelled > 0 ? "t-danger" : "" },
  ];

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12, marginBottom: 16 }}>
      {cards.map(({ label, value, accent, sub, valueClass }) => (
        <div key={label} style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 12, padding: 16, position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: accent }} />
          <div className="fs10 tc3" style={{ marginBottom: 8, textTransform: "uppercase", letterSpacing: ".1em", fontWeight: 700 }}>{label}</div>
          <div className={`syne fw7 fs22 ${valueClass}`}>{value}</div>
          {sub && <div className="fs10 tc3" style={{ marginTop: 4 }}>{sub}</div>}
        </div>
      ))}
    </div>
  );
}

// ─── Main Page ────────────────────────────────────────────────────────────────
function AllocationHistoryPage({ showToast: toast, onBack }) {
  const [search,       setSearch]       = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterSite,   setFilterSite]   = useState("all");
  const [filterProd,   setFilterProd]   = useState("all");

  const sites    = [...new Set(MOCK_ALLOCATIONS.map((a) => a.site))];
  const products = [...new Set(MOCK_ALLOCATIONS.map((a) => a.product))];

  const filtered = MOCK_ALLOCATIONS.filter((a) => {
    if (filterStatus !== "all" && a.status !== filterStatus) return false;
    if (filterSite   !== "all" && a.site    !== filterSite)  return false;
    if (filterProd   !== "all" && a.product !== filterProd)  return false;
    if (search) {
      const q = search.toLowerCase();
      return a.employee.toLowerCase().includes(q) || a.orderId.toLowerCase().includes(q) || a.id.toLowerCase().includes(q);
    }
    return true;
  });

  return (
    <div className="page">
      {/* breadcrumb */}
      <div className="fc gap8 mb16">
        <button className="btn btn-g btn-sm" onClick={onBack} style={{ gap: 5 }}>
          <i className="bi bi-arrow-left" style={{ fontSize: 11 }} /> Reporting
        </button>
        <span className="tc3 fs11">/</span>
        <span className="fs11 tc2">Allocation History</span>
      </div>

      {/* hero */}
      <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 14, padding: "18px 22px", marginBottom: 16, display: "flex", alignItems: "center", gap: 16 }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: "linear-gradient(135deg,var(--blue),var(--teal))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 20, boxShadow: "0 0 20px rgba(64,196,255,.25)", flexShrink: 0 }}>
          📦
        </div>
          <div style={{ flex: 1 }}>
          <div className="syne fw7" style={{ fontSize: 17 }}>Allocation History</div>
          <div className="fs11 tc3" style={{ marginTop: 3 }}>Stock reservations per order — site source, fulfilment status, and any adjustments made</div>
        </div>
       {/* <button className="btn btn-s btn-sm" onClick={() => toast("Exported", "s")}>
          <i className="bi bi-file-earmark-pdf" /> Export PDF
        </button>*/}
      </div>

      <AllocationKPIs allocations={MOCK_ALLOCATIONS} />

      <div className="g6040">
        {/* LEFT: main table */}
        <div>
          <div className="panel">
            {/* toolbar */}
            <div className="tbar">
              <div className="tsearch">
                    <i className="bi bi-search" style={{ color: "var(--text3)", fontSize: 12 }} />
                    <input placeholder="Search employee, order, allocation…" value={search} onChange={(e) => setSearch(e.target.value)} />
                  </div>
              <select className="tfilter" value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}>
                <option value="all">All Statuses</option>
                {Object.keys(STATUS_COLORS).map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
                  <select className="tfilter" value={filterSite} onChange={(e) => setFilterSite(e.target.value)}>
                    <option value="all">All Sites</option>
                    {sites.map((s) => <option key={s} value={s}>{s}</option>)}
                  </select>
              <select className="tfilter" value={filterProd} onChange={(e) => setFilterProd(e.target.value)}>
                <option value="all">All Products</option>
                {products.map((p) => <option key={p} value={p}>{p}</option>)}
              </select>
            </div>

            <table className="tbl">
              <thead>
                <tr>
                  <th>Alloc. ID</th>
                  <th>Order</th>
                  <th>Employee / ID</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Site</th>
                  <th>Allocated By</th>
                  <th>Allocated At</th>
                  <th>Fulfilled At</th>
                  <th>Adj.</th>
                  <th>Status</th>
                  {/* <th></th> */}
                </tr>
              </thead>
              <tbody>
                {filtered.map((a) => (
                  <tr key={a.id}>
                    <td className="mono t-flame" style={{ fontSize: 11 }}>{a.id}</td>
                    <td className="mono fw6" style={{ fontSize: 11, color: "var(--blue)" }}>{a.orderId}</td>
                    <td className="fs12 fw6" style={{ maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.employee} · <span className="mono">{a.employeeId}</span></td>
                    <td className="fs11 tc2">{a.product}</td>
                    <td className="mono fs11 fw7">{a.qty} {a.unit}</td>
                    <td><span className="tag">{a.site}</span></td>
                    <td className="fs11 tc2">{a.allocatedBy}</td>
                    <td className="mono fs10 tc3">{a.allocatedAt}</td>
                    <td className="mono fs10 tc3">{a.fulfilledAt || <span className="tc3">—</span>}</td>
                    <td>
                      {a.adjustments > 0
                        ? <span className="mono fw7 fs11" style={{ color: "var(--amber)" }}>{a.adjustments}</span>
                        : <span className="tc3 fs11">—</span>}
                    </td>
                    <td><StatusPill status={a.status} /></td>
                    <td>
                     {/* <button className="btn btn-g btn-sm btn-ico" onClick={() => toast(`${a.id} detail`, "s")}>
                        <i className="bi bi-arrow-up-right" style={{ fontSize: 10 }} />
                      </button>*/}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {filtered.length === 0 && (
              <div className="empty"><div className="empty-ico">📦</div><div>No allocations match your filters</div></div>
            )}

            <div style={{ padding: "12px 18px", borderTop: "1px solid var(--border)", display: "flex", gap: 24, alignItems: "center" }}>
              <span className="fs11 tc3">Showing {filtered.length} of {MOCK_ALLOCATIONS.length}</span>
              <span className="fs11 tc3">|</span>
              <span className="fs11 tc2">Total volume: <span className="mono fw7">{filtered.reduce((s, a) => s + a.qty, 0).toLocaleString()} units</span></span>
            </div>
          </div>
        </div>

        {/* RIGHT: site breakdown + adjustment log */}
        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <SiteBreakdown allocations={MOCK_ALLOCATIONS} />

          <div className="panel">
            <div className="ph"><span className="ph-title">Recent Adjustments</span></div>
            <div style={{ padding: "14px 18px" }}>
              {MOCK_ALLOCATIONS.filter((a) => a.adjustments > 0).map((a, i, arr) => (
                <div key={a.id} style={{ display: "flex", gap: 10, paddingBottom: 12, marginBottom: i < arr.length - 1 ? 12 : 0, borderBottom: i < arr.length - 1 ? "1px solid var(--border)" : "none" }}>
                  <div style={{ width: 28, height: 28, borderRadius: "50%", background: "rgba(255,171,0,.12)", border: "1px solid rgba(255,171,0,.3)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                    <i className="bi bi-pencil-square" style={{ fontSize: 11, color: "var(--amber)" }} />
                  </div>
                  <div>
                    <div className="fs12 fw6" style={{ marginBottom: 2 }}>{a.id} — {a.employee}</div>
                    <div className="fs11 tc3">{a.product} · {a.adjustments} adjustment{a.adjustments > 1 ? "s" : ""} made</div>
                    <div className="fs10 tc3" style={{ marginTop: 2 }}>{a.allocatedAt}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="panel">
            <div className="ph"><span className="ph-title">Product Mix</span></div>
            <div style={{ padding: "14px 18px" }}>
              {[...new Set(MOCK_ALLOCATIONS.map((a) => a.product))].map((p) => {
                const count = MOCK_ALLOCATIONS.filter((a) => a.product === p).length;
                const pct   = Math.round((count / MOCK_ALLOCATIONS.length) * 100);
                return (
                  <div key={p} style={{ marginBottom: 12 }}>
                    <div className="fb" style={{ marginBottom: 5 }}>
                      <span className="fs11 fw6">{p}</span>
                      <span className="mono fs10 tc3">{count} orders · {pct}%</span>
                    </div>
                    <div className="prog-wrap" style={{ height: 5 }}>
                      <div className="prog-fill" style={{ width: `${pct}%`, background: "var(--blue)" }} />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AllocationHistoryPage;
export { MOCK_ALLOCATIONS };